import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const LanguageSelect = () => {
  return <Root>
    <Link to="/">EN</Link>|<Link to="/zh">中文</Link>
  </Root>;
}

const Root = styled.div`
  color: #fff;
  position: absolute;
  top: 15px;
  right: 24px;
  letter-spacing: 1.83px;
  font-size: 11px;
  a {
    color: #fff;
    padding: 0 10px;
    position: relative;
  }
  @media (max-width: ${({theme}) => theme.headerMobileWidth}) {
    display: none;
  }
`;

export default LanguageSelect;


// WEBPACK FOOTER //
// ./src/components/Header/elements/LanguageSelect.js